import { render, staticRenderFns } from "./ActionsAutomation.vue?vue&type=template&id=a8172dc6"
import script from "./ActionsAutomation.vue?vue&type=script&lang=js"
export * from "./ActionsAutomation.vue?vue&type=script&lang=js"
import style0 from "./ActionsAutomation.vue?vue&type=style&index=0&id=a8172dc6&prod&lang=scss&media=screen"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports